import { IUserFacingMessages } from '../Interfaces';

const UserFacingMessagesEN: IUserFacingMessages = {
  'ok': `Request successful!`,
  'request-fail': `Something went wrong with the request`,
  'server-fail': `The server is unavailable at this time`,
}

export default UserFacingMessagesEN
